import _ from "lodash";

export const mapResourceObjectToArray = (resourceObj) =>
    _.map(resourceObj, (d) => ({ id: d.id, ...d.attributes }));

export const extractResourceAttributes = (resource) => mapResourceObjectToArray(resource)[0] || {};

export const generateEntityLabel = (entity, entityOptions) => {
    const labelKeys = !_.isNil(entityOptions.itemLabels)
        ? entityOptions.itemLabels
        : [entityOptions.filterValue];

    let labelValue = "";

    if (entity.attributes) {
        labelKeys.forEach((key, i) => {
            labelValue += entity.attributes[key] + (i < labelKeys.length - 1 ? " | " : "");
        });
    }

    return labelValue;
};
